import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import STRINGS from '../constants';
import getComponentWithTheme from '../../themeProvider';
import ApplyPageHeader from '../../sma.common/components/react/components/ApplyPageHeader';
import AccountSettingsPage from './pages/AccountSettingsPage/AccountSettingsPage';
import SystemAlerts from '../../sma.common/components/react/components/SystemAlerts';

const AccountSettings = (props) => {
	const {
		page,
		singleSignOnEnabled,
		userId,
		csrfToken,
		usesSso,
		languages,
		timezones,
		siteInfo,
		assumedRole,
		userDetails,
	} = props;

	const defaultTabs = {
		myProfileTab: {
			label: STRINGS.accountSettingsPage.myProfileTab.title,
			active: true,
			id: 'myProfileTab',
		},
		userSectionTab: {
			label: STRINGS.accountSettingsPage.userSectionTab.title,
			active: false,
			id: 'userSectionTab',
		},
		notificationSettingsTab: {
			label: STRINGS.accountSettingsPage.notificationSettingsTab.title,
			active: false,
			id: 'notificationSettingsTab',
		},
	};

	const [tabs, setTabs] = useState(defaultTabs);
	const [selectedTab, setSelectedTab] = useState('myProfileTab');
	const [tabErrors, setTabErrors] = useState({});
	const headerTitle = STRINGS[page].title;

	useEffect(() => {
		if (siteInfo.eligibilityEnabled && userDetails.rolesWithIds.some((role) => role.id === 'applicant')) {
			setTabs({
				...tabs,
				userEligibilityTab: {
					label: STRINGS.accountSettingsPage.userEligibilityTab.title,
					active: false,
					id: 'userEligibilityTab',
				},
			});
		}
	}, []);

	const handleTabChange = (tabName) => {
		setSelectedTab(tabName);
		setTabs({
			...tabs,
			[selectedTab]: {
				...tabs[selectedTab],
				active: false,
			},
			[tabName]: {
				...tabs[tabName],
				active: true,
			},
		});
	};

	return (
		getComponentWithTheme(
			<>
				<SystemAlerts />
				<ApplyPageHeader
					headerTitle={headerTitle}
					tabs={tabs}
					selectedTab={selectedTab}
					handleTabChange={handleTabChange}
					tabErrors={tabErrors}
				/>
				<AccountSettingsPage
					selectedTab={selectedTab}
					singleSignOnEnabled={singleSignOnEnabled}
					userId={userId}
					csrfToken={csrfToken}
					languages={languages}
					timezones={timezones}
					usesSso={usesSso}
					assumedRole={assumedRole}
					siteInfo={siteInfo}
					userDetails={userDetails}
					tabErrors={tabErrors}
					setTabErrors={setTabErrors}
				/>
			</>,
		)
	);
};
AccountSettings.propTypes = {
	page: PropTypes.string.isRequired,
	singleSignOnEnabled: PropTypes.bool.isRequired,
	userId: PropTypes.string.isRequired,
	csrfToken: PropTypes.string.isRequired,
	usesSso: PropTypes.bool.isRequired,
	assumedRole: PropTypes.object,
	siteInfo: PropTypes.object.isRequired,
	userDetails: PropTypes.object.isRequired,
};

AccountSettings.defaultProps = { assumedRole: {} };

export default AccountSettings;
